/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */
import type {
    ApplicationCreateRequest,
    ApplicationResponse,
    ApplicationUpdateRequest,
    GetApplicationsParams,
    PagedResponseApplicationResponse
} from '../models';

export type getApplicationResponse200 = {
    data: ApplicationResponse;
    status: 200;
};

export type getApplicationResponse400 = {
    data: void;
    status: 400;
};

export type getApplicationResponse500 = {
    data: void;
    status: 500;
};

export type getApplicationResponseSuccess = getApplicationResponse200 & {
    headers: Headers;
};

export type getApplicationResponseError = (
    | getApplicationResponse400
    | getApplicationResponse500
) & {
    headers: Headers;
};

export type getApplicationResponse = getApplicationResponseSuccess | getApplicationResponseError;

export const getGetApplicationUrl = (id: string) => `/api/v1/applications/${id}`;

export const getApplication = async (
    id: string,
    options?: RequestInit
): Promise<getApplicationResponse> => {
    const res = await fetch(getGetApplicationUrl(id), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getApplicationResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getApplicationResponse;
};

export type updateApplicationResponse200 = {
    data: ApplicationResponse;
    status: 200;
};

export type updateApplicationResponse400 = {
    data: void;
    status: 400;
};

export type updateApplicationResponse500 = {
    data: void;
    status: 500;
};

export type updateApplicationResponseSuccess = updateApplicationResponse200 & {
    headers: Headers;
};

export type updateApplicationResponseError = (
    | updateApplicationResponse400
    | updateApplicationResponse500
) & {
    headers: Headers;
};

export type updateApplicationResponse =
    | updateApplicationResponseSuccess
    | updateApplicationResponseError;

export const getUpdateApplicationUrl = (id: string) => `/api/v1/applications/${id}`;

export const updateApplication = async (
    id: string,
    applicationUpdateRequest: ApplicationUpdateRequest,
    options?: RequestInit
): Promise<updateApplicationResponse> => {
    const res = await fetch(getUpdateApplicationUrl(id), {
        ...options,
        body: JSON.stringify(applicationUpdateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'PUT'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: updateApplicationResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as updateApplicationResponse;
};

export type assignBoundaryToApplicationResponse204 = {
    data: void;
    status: 204;
};

export type assignBoundaryToApplicationResponse400 = {
    data: void;
    status: 400;
};

export type assignBoundaryToApplicationResponse500 = {
    data: void;
    status: 500;
};

export type assignBoundaryToApplicationResponseSuccess = assignBoundaryToApplicationResponse204 & {
    headers: Headers;
};

export type assignBoundaryToApplicationResponseError = (
    | assignBoundaryToApplicationResponse400
    | assignBoundaryToApplicationResponse500
) & {
    headers: Headers;
};

export type assignBoundaryToApplicationResponse =
    | assignBoundaryToApplicationResponseSuccess
    | assignBoundaryToApplicationResponseError;

export const getAssignBoundaryToApplicationUrl = (id: string, boundaryId: string) =>
    `/api/v1/applications/${id}/boundaries/${boundaryId}`;

export const assignBoundaryToApplication = async (
    id: string,
    boundaryId: string,
    options?: RequestInit
): Promise<assignBoundaryToApplicationResponse> => {
    const res = await fetch(getAssignBoundaryToApplicationUrl(id, boundaryId), {
        ...options,
        method: 'PUT'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: assignBoundaryToApplicationResponse['data'] = body ? JSON.parse(body) : undefined;

    return {
        data,
        headers: res.headers,
        status: res.status
    } as assignBoundaryToApplicationResponse;
};

export type getApplicationsResponse200 = {
    data: PagedResponseApplicationResponse;
    status: 200;
};

export type getApplicationsResponse400 = {
    data: void;
    status: 400;
};

export type getApplicationsResponse500 = {
    data: void;
    status: 500;
};

export type getApplicationsResponseSuccess = getApplicationsResponse200 & {
    headers: Headers;
};

export type getApplicationsResponseError = (
    | getApplicationsResponse400
    | getApplicationsResponse500
) & {
    headers: Headers;
};

export type getApplicationsResponse = getApplicationsResponseSuccess | getApplicationsResponseError;

export const getGetApplicationsUrl = (params?: GetApplicationsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['sort'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach(v => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/api/v1/applications?${stringifiedParams}`
        : `/api/v1/applications`;
};

export const getApplications = async (
    params?: GetApplicationsParams,
    options?: RequestInit
): Promise<getApplicationsResponse> => {
    const res = await fetch(getGetApplicationsUrl(params), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getApplicationsResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getApplicationsResponse;
};

export type createApplicationResponse201 = {
    data: ApplicationResponse;
    status: 201;
};

export type createApplicationResponse400 = {
    data: void;
    status: 400;
};

export type createApplicationResponse500 = {
    data: void;
    status: 500;
};

export type createApplicationResponseSuccess = createApplicationResponse201 & {
    headers: Headers;
};

export type createApplicationResponseError = (
    | createApplicationResponse400
    | createApplicationResponse500
) & {
    headers: Headers;
};

export type createApplicationResponse =
    | createApplicationResponseSuccess
    | createApplicationResponseError;

export const getCreateApplicationUrl = () => `/api/v1/applications`;

export const createApplication = async (
    applicationCreateRequest: ApplicationCreateRequest,
    options?: RequestInit
): Promise<createApplicationResponse> => {
    const res = await fetch(getCreateApplicationUrl(), {
        ...options,
        body: JSON.stringify(applicationCreateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'POST'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: createApplicationResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as createApplicationResponse;
};

export type archiveApplicationResponse204 = {
    data: void;
    status: 204;
};

export type archiveApplicationResponse400 = {
    data: void;
    status: 400;
};

export type archiveApplicationResponse500 = {
    data: void;
    status: 500;
};

export type archiveApplicationResponseSuccess = archiveApplicationResponse204 & {
    headers: Headers;
};

export type archiveApplicationResponseError = (
    | archiveApplicationResponse400
    | archiveApplicationResponse500
) & {
    headers: Headers;
};

export type archiveApplicationResponse =
    | archiveApplicationResponseSuccess
    | archiveApplicationResponseError;

export const getArchiveApplicationUrl = (id: string) => `/api/v1/applications/${id}/archive`;

export const archiveApplication = async (
    id: string,
    options?: RequestInit
): Promise<archiveApplicationResponse> => {
    const res = await fetch(getArchiveApplicationUrl(id), {
        ...options,
        method: 'POST'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: archiveApplicationResponse['data'] = body ? JSON.parse(body) : undefined;

    return { data, headers: res.headers, status: res.status } as archiveApplicationResponse;
};
